// src/pdfWorker.js
import { pdfjs } from "react-pdf";
 
// Load matching worker from CDN
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;